import { Text } from "epsy-ui-react"
import { Theme } from "src/API"
import styled, { DefaultTheme } from "styled-components"

export const mobileMax = 1228
export const mobileMq = `@media (max-width: ${mobileMax}px)`

export const TitleText = styled(Text).attrs(({ theme }) => ({
  size: 24,
  bold: theme.mode === Theme.Epsy
}))`
  color: ${(p) =>
    p.theme.mode === Theme.Epsy ? p.theme.oldColors.lozenge.textColor : p.theme.oldColors.primary.purple};
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  ${mobileMq} {
    overflow-wrap: anywhere;
    flex-flow: column;
  }
`

const descriptionLogoMap: Record<DefaultTheme["mode"], string> = {
  Epsy: "/images/epsy-floating-right-image.svg",
  LivaNova: "/images/hcp-floating-right-image.svg"
}

export const DescriptionLogo = styled.img.attrs(({ theme }) => ({
  src: descriptionLogoMap[theme.mode]
}))`
  width: 100%;
  @media print {
    display: none;
  }
`

export const DescriptionTitle = styled(Text).attrs(({ theme }) => ({
  color: theme.colors.white,
  fontSize: 24
}))`
  padding-top: ${(p) => (p.theme.mode === Theme.LivaNova ? "20px" : "10px")};
  text-align: center;
`

export const Inner = styled.div`
  max-width: 445px;
  max-height: 700px;
  border-radius: 12px;
  border: 1px solid #e8e8ec;
  padding: 24px 40px;
  margin: 0 auto;
  background: ${(p) => p.theme.colors.white};
  align-self: center;
  ${mobileMq} {
    margin: 0 auto;
  }
`

export const SubmitErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 0;
  min-height: 45px;
`

export const RightContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  background-color: ${(p) =>
    p.theme.mode === Theme.LivaNova ? p.theme.oldColors.secondary.indigo : p.theme.oldColors.primary.purple};
  padding: 50px 50px 0 50px;

  ${mobileMq} {
    display: none;
  }
`

export const LeftContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  background-image: url(/images/hcp-left-bg.svg);
  background-size: cover;
  padding: 50px 50px 0 50px;
`

export const FooterContainer = styled.div`
  min-height: 50px;
  .footer-wrapper {
    padding: 0 !important;
  }
`
